module.exports = "https://static.energy5.com/_next/static/images/brand4-d71396d691abe0fff11eedfd8ef1a83a.png";